// Constants
function initForm() {
  const newsletterForm = {
    name: 'newsletter',
    elem: document.querySelector('.js-newsletter-form'),
    elemConfirm: document.querySelector('.js-newsletter-form__confirmation'),
    ajax: true,
    json: false,

    fields: {
      email: {
        elem: document.querySelector('.js-newsletter-form__email'),
        errorElem: document.querySelector('.js-newsletter-form__error--email'),
        errorMessage: document.querySelector('.js-newsletter-form__error--email').dataset.errorMessage,
        valid: false,
      },
    },
  };

  return newsletterForm;
}

export default {
  initForm,
};
